import { GalleryTheme } from '../../types';

export const GALLERY_DEFAULT_THEME: GalleryTheme = {
    thumnailSize: {
        width: 120,
        height: 67,
    },
    control: {
        height: 36,
        typographyVariant: 'body.s',
        fontWeight: 'semiBold',
        radius: 10,
        backgroundColor: 'common.white',
        color: 'text.heading',
        iconSize: 20,
        iconClearance: 4,
    },
    navButton: {
        width: 28,
        iconSize: 16,
    },
};
